import { render, staticRenderFns } from "./ImmersiveToolbar.vue?vue&type=template&id=10f7c23a&scoped=true"
import script from "./ImmersiveToolbar.vue?vue&type=script&lang=js"
export * from "./ImmersiveToolbar.vue?vue&type=script&lang=js"
import style0 from "./ImmersiveToolbar.vue?vue&type=style&index=0&id=10f7c23a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f7c23a",
  null
  
)

export default component.exports